var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronsLeftRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57486 16L16.5811 5.53748C17.1514 4.93786 17.1339 3.98873 16.5342 3.41623C15.9346 2.84373 14.9861 2.86498 14.4174 3.46248L3.41736 14.9625C2.86267 15.5445 2.86267 16.455 3.41736 17.0369L14.4174 28.5369C14.9896 29.1345 15.9386 29.156 16.5386 28.5837C16.8424 28.2875 16.9986 27.8937 16.9986 27.5C16.9986 27.1269 16.8599 26.7537 16.5826 26.4631L6.57486 16ZM28.5799 26.4625L18.5736 16L28.5799 5.53748C29.1502 4.93786 29.1326 3.98873 28.533 3.41623C27.9334 2.84373 26.9842 2.86542 26.4117 3.46311L15.4117 14.9631C14.857 15.5452 14.857 16.4556 15.4117 17.0375L26.4117 28.5375C26.984 29.1352 27.933 29.1567 28.533 28.5844C28.8424 28.2875 28.9986 27.8937 28.9986 27.5C28.9986 27.125 28.8611 26.7562 28.5799 26.4625Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsLeftRegular);
export default __webpack_public_path__ + "static/media/chevrons-left-regular.37a0d573ba9f049759c8aa335b302ac2.svg";
export { ForwardRef as ReactComponent };